module.exports = {"id":"203551","name":"Alessandro Florenzi","rating":"82","photo":"./data/images/photos/3/203551.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["DD","AD","MC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlessandroFlorenzi0.json
// module id = 194
// module chunks = 0